// extracted by mini-css-extract-plugin
export default {"normalcn":"styles_normalcn__D7TGf","normalen":"styles_normalen__8duJZ"};